import { IElement, IPage } from '../types'

import { ELEMENTS_LOOKUP } from '../const'

export const floatingElementsSet = new Set([
  ELEMENTS_LOOKUP.INITIALS_FIELD,
  ELEMENTS_LOOKUP.SIGNATURE,
  ELEMENTS_LOOKUP.DATE_FIELD,
  ELEMENTS_LOOKUP.CHECKBOX,
  ELEMENTS_LOOKUP.TEXT_FIELD,
])
export const blockElementsSet = new Set([
  ELEMENTS_LOOKUP.TEXT,
  ELEMENTS_LOOKUP.IMAGE,
  ELEMENTS_LOOKUP.VIDEO,
  ELEMENTS_LOOKUP.TABLE,
  ELEMENTS_LOOKUP.PRODUCT_LIST,
])

export const flatChildrens = (pages: IPage[]) => {
  return pages.reduce((acc, page) => {
    page.children?.forEach(element => {
      if (element.type === ELEMENTS_LOOKUP.ROW) {
        element.children?.forEach(column => {
          column.children?.forEach(child => {
            acc.push(child)
            if (child?.children && child?.children?.length > 0) {
              child.children.forEach(grandChild => {
                acc.push(grandChild)
              })
            }
          })
        })
      } else {
        acc.push(element)
        if (element?.children && element?.children?.length > 0) {
          element.children.forEach(child => {
            acc.push(child)
          })
        }
      }
    })
    return acc
  }, [] as IElement[])
}

/**
 * Returns all block elements in the document (excluding nested block elements) which are one of
 * TEXT, IMAGE, VIDEO, TABLE, PRODUCT_LIST
 * @param pages
 * @returns
 */
export const flatBlockChildrens = (pages: IPage[]) => {
  return pages.reduce((acc, page) => {
    page.children?.forEach(element => {
      if (element.type === ELEMENTS_LOOKUP.ROW) {
        element.children?.forEach(column => {
          column.children?.forEach(child => {
            if (blockElementsSet.has(child.type)) {
              acc.push(child)
            }
            if (child?.children && child?.children?.length > 0) {
              child.children.forEach(grandChild => {
                if (blockElementsSet.has(grandChild.type)) {
                  acc.push(grandChild)
                }
              })
            }
          })
        })
      } else {
        if (blockElementsSet.has(element.type)) {
          acc.push(element)
        }
        if (element?.children && element?.children?.length > 0) {
          element.children.forEach(child => {
            if (blockElementsSet.has(child.type)) {
              acc.push(child)
            }
          })
        }
      }
    })
    return acc
  }, [] as IElement[])
}
